import script from "./Next.vue?vue&type=script&setup=true&lang=js"
export * from "./Next.vue?vue&type=script&setup=true&lang=js"

import "./Next.vue?vue&type=style&index=0&id=0b5b46ca&lang=css"

const __exports__ = script;

export default __exports__